import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../auth/AuthContext';
import AuthModal from './AuthModal';
import EmailVerificationGate from './EmailVerificationGate';
import OnboardingIntentModal from './OnboardingIntentModal';

const ProtectedLearningRoute = ({ children }) => {
  const { loading, user } = useAuth();

  if (loading) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {user ? children : null}
      <AuthModal />
      <EmailVerificationGate />
      <OnboardingIntentModal />
    </>
  );
};

export default ProtectedLearningRoute;
